module.exports = __webpack_public_path__ + "img/product10.b1426455.jpg";